type TokenBuddyLogoProps = {
  className?: string;
  showAi?: boolean;
};

export function TokenBuddyLogo({ className = "", showAi = true }: TokenBuddyLogoProps) {
  return (
    <span className={["inline-flex min-w-0 items-center gap-2", className].join(" ")}>
      <TokenBuddyMark />
      <span className="min-w-0 font-mono text-[0.88rem] font-black uppercase leading-none tracking-[0.12em] text-[var(--color-ink)]">
        Token<span className="text-[var(--color-primary)]">Buddy</span>{showAi ? <span className="text-[var(--color-muted)]">.AI</span> : null}
      </span>
    </span>
  );
}

function TokenBuddyMark() {
  return (
    <svg className="size-7 shrink-0" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <rect x="2.5" y="2.5" width="27" height="27" rx="8" fill="#ffffff" stroke="var(--color-line)" />
      <path d="M9.5 19.5V12.5L16 8.75L22.5 12.5V19.5L16 23.25L9.5 19.5Z" fill="var(--color-primary-soft)" stroke="var(--color-primary)" strokeWidth="1.7" strokeLinejoin="round" />
      <path d="M16 8.75V23.25M9.5 12.5L16 16.25L22.5 12.5" fill="none" stroke="var(--color-primary-deep)" strokeWidth="1.45" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="23.25" cy="8.75" r="2.35" fill="var(--color-success)" stroke="#ffffff" strokeWidth="1.3" />
    </svg>
  );
}
